<template>
  <v-container v-if="resume.professionalSkills.length > 0" class="pt-0 pb-0 mb-3">
    <BaseDivider :title="this.$t('professional_skills')" />
    <div v-for="(skill, i) in resume.professionalSkills" :key="i">
      <template>
        <span class="mx-2">{{ skill.title }}</span>
        <ProficiencyRate :value="skill.proficiency" />
      </template>
    </div>
  </v-container>
</template>

<script>
import { mapState } from "pinia";
import { useCreateResumeStore } from "@/modules/create_resume/store/CreateResumeStore";

import ProficiencyRate from "./ProficiencyRate.vue";
import BaseDivider from "./BaseDivider.vue";

export default {
  components: { ProficiencyRate, BaseDivider },
  computed: {
    ...mapState(useCreateResumeStore, ["resume"]),
  },
};
</script>

<style></style>
